module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user-management"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Organisasi")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Daftar Organisasi")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Organizations Management")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("\n            Daftar Organisasi\n          ")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "5px",
      "font-size": "11px"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/organizations/form')
      }
    }
  }, [_vm._v("Buat Organisasi")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "searchbox",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Masukkan kata kunci dan tekan enter"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loadOrganizationsData(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.organizations), function(organization, key) {
    return _c('tr', {
      key: key,
      on: {
        "dblclick": function($event) {
          return _vm.goToDetail(organization.id)
        }
      }
    }, [_c('td', [_vm._v(_vm._s((25 * (_vm.pageNumber - 1)) + (key + 1)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(organization.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(organization.child_count))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "disabled": _vm.pageNumber === 1,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadOrganizationsData(--_vm.pageNumber)
      }
    }
  }, [_vm._v("\n              Previous\n            ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "width": "50px",
      "text-align": "center"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.pageNumber + ' / ' + _vm.total_page
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "disabled": _vm.isDisabledNextBtn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadOrganizationsData(++_vm.pageNumber)
      }
    }
  }, [_vm._v("\n              Next\n            ")])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("No.")]), _vm._v(" "), _c('th', [_vm._v("Nama Organisasi")]), _vm._v(" "), _c('th', [_vm._v("Jumlah Cabang")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23a6450a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organizations/Organizations.vue
// module id = 1305
// module chunks = 0